import * as m from "mithril";
import AppContext from "../../context/AppContext";
import { NavBar } from '../../components/NavBar';
import { ArticleDTO, InternationalStringDTO } from "../../apiclient/ApiDtos";
import LoadingIndicator from "../../components/LoadingIndicator";
import buildLanguageChangeActions from "../common/LanguageNavActions";
import { getIntlStringValue } from "../../helpers/StringHelpers";

interface Attrs{
    appContext: AppContext,
    title: InternationalStringDTO,    
    article?: ArticleDTO | null,
    onBackPressed: () => void,
}

function ArticlePage(): m.Component<Attrs> {
    return {        
        view(vnode) {
            let article = vnode.attrs.article;
            let messageProvider = vnode.attrs.appContext.getMessageProvider();
            let lang = messageProvider.getCurrentLang();
            let langChangeActionItems = buildLanguageChangeActions(vnode.attrs.appContext);

            return m('div', { class: "app-layout" },
                [
                    m(NavBar, {
                        title: (article)? getIntlStringValue(article.title, lang) : getIntlStringValue(vnode.attrs.title, lang),
                        canBackPress: true,
                        onBackPressed: () => vnode.attrs.onBackPressed(),
                        actionItems: langChangeActionItems,
                    }),

                    m("div.app-area-main p-2", 
                        (article != null)?
                        m.trust(getIntlStringValue(article.body, lang)) : m(LoadingIndicator)                      
                    ),
                ]);
        }
    }
};

export default ArticlePage;